import { Component, OnInit, ViewChild, ElementRef, HostBinding } from '@angular/core'

import { auth } from 'firebase'

@Component({
  selector: 'app-recaptcha',
  template: '<button #verifier></button>',
  styles: [
    ':host { position: fixed; bottom: 1em; left: 50%; transform: translateX(-50%); overflow: hidden; }',
    ':host { transition: height .2s 10s cubic-bezier(.8,-2,.8,.2); height: 0em; }',
    ':host[collapse] { height: 0; }',
    'button { display: none }',
  ]
})
export class RecaptchaComponent implements OnInit {
  static recaptchaVerifier: auth.RecaptchaVerifier

  @HostBinding('attr.collapse') collapse: ('' | null)
  @ViewChild('verifier') verificationButton: ElementRef

  constructor() { }

  get verifier () {
    if (!RecaptchaComponent.recaptchaVerifier) {
      RecaptchaComponent.recaptchaVerifier = new auth.RecaptchaVerifier(
        this.verificationButton.nativeElement, {
          size: 'invisible',
          badge: 'inline',
          hl: 'en',
          'expired-callback': () => this.resetRecaptcha()
        }
      )
    }
    return RecaptchaComponent.recaptchaVerifier
  }

  ngOnInit() {
  }

  resetRecaptcha () {
    this.verifier.render()
  }

}
